import React from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import SummaryPicture from '../../ContentGrid/SummaryPicture'
import { twMerge } from 'tailwind-merge'
import FadeIn from '../../../components/Animation/FadeIn'

interface TestimonialPictureProps {
  slug: string
  className: string
  onLoad?: () => void
}

const TestimonialPicture = ({ slug, className, onLoad }: TestimonialPictureProps) => {
    return (
        <FadeIn>
            <SwitchTransition mode='out-in'>
                <CSSTransition
                    key={slug}
                    addEndListener={(node, done) => {
                        node.addEventListener('transitionend', done, false)
                    }}
                    classNames='fade'
                >
                    <SummaryPicture
                        slug={slug}
                        imageClassName={twMerge('aspect-auto', className)}
                        className='p-0 pt-16'
                        onLoad={onLoad}
                    />
                </CSSTransition>
            </SwitchTransition>
        </FadeIn>
    )
}

export default TestimonialPicture
